<template>
    <span class="animated-dots"><span>.</span><span>.</span><span>.</span></span>
</template>

<style lang="scss" scoped>
    .animated-dots {
        display: inline-flex; /* Remove space in between dots */
        span {
            animation: blink 1.4s infinite ease-in-out both;
            &:nth-child(2) {
                animation-delay: 0.2s;
            }
            &:nth-child(3) {
                animation-delay: 0.4s;
            }
        }
    }

    @keyframes blink {
        0% {
            opacity: 0.1;
        }
        20% {
            opacity: 1;
        }
        100% {
            opacity: 0.1;
        }
    }
</style>
